import { fontSize, fontWeight } from '@/src/core/utils/typography';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  // Shared
  container: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    padding: 16,
    paddingBottom: 32,
  },

  // Standalone (unauthenticated)
  standaloneContainer: {
    flex: 1,
  },
  standaloneScrollContent: {
    flexGrow: 1,
    padding: 16,
    paddingBottom: 40,
    maxWidth: 600,
    alignSelf: 'center',
    width: '100%',
  },

  // Top bar
  topBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
  },
  topBarLogo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  topBarIcon: {
    width: 32,
    height: 32,
  },
  topBarBrand: {
    fontSize: fontSize.lg,
    fontWeight: fontWeight.bold,
  },
  topBarSignUp: {
    paddingHorizontal: 14,
    paddingVertical: 6,
    borderRadius: 20,
    borderWidth: 1.5,
  },
  topBarSignUpText: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.semibold,
  },

  // Post card
  card: {
    borderRadius: 12,
    borderWidth: 1,
    padding: 16,
    marginBottom: 16,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 6,
    elevation: 2,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 14,
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: 22,
    marginRight: 12,
  },
  avatarPlaceholder: {
    width: 44,
    height: 44,
    borderRadius: 22,
    marginRight: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  userName: {
    fontSize: fontSize.body,
    fontWeight: fontWeight.semibold,
    marginBottom: 2,
  },
  timestamp: {
    fontSize: fontSize.sm,
  },
  content: {
    fontSize: fontSize.body,
    lineHeight: 22,
    marginBottom: 14,
  },
  image: {
    width: '100%',
    aspectRatio: 1,
    borderRadius: 8,
    marginBottom: 14,
  },

  // Meta row (tournament badge + likes)
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 12,
    borderTopWidth: 1,
  },
  metaSpacer: {
    flex: 1,
  },
  likeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  likeCount: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
  },
  tournamentBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 16,
    gap: 5,
  },
  tournamentName: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    flexShrink: 1,
  },

  // CTA section
  ctaSection: {
    borderRadius: 16,
    borderWidth: 1,
    padding: 24,
    alignItems: 'center',
    gap: 10,
  },
  ctaIcon: {
    width: 64,
    height: 64,
    marginBottom: 4,
  },
  ctaTitle: {
    fontSize: fontSize.xl,
    fontWeight: fontWeight.bold,
    textAlign: 'center',
  },
  ctaSubtitle: {
    fontSize: fontSize.body,
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 8,
  },
  ctaPrimaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 28,
    paddingVertical: 14,
    borderRadius: 12,
    width: '100%',
    justifyContent: 'center',
  },
  ctaPrimaryButtonText: {
    fontSize: fontSize.body,
    fontWeight: fontWeight.bold,
    color: '#fff',
  },
  ctaSecondaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 8,
  },
  ctaSecondaryButtonText: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
  },
});
